import { AxisTickPadding, AxisTickSize, DarkDashedGridColor, DarkTextColor, DashedGridSize, LegendFontSize, LegendOffset, LightDashedGridColor, LightTextColor, } from '../constants';
import { formatDate } from '../formatters/formatDate';
import { formatNumber } from '../formatters/formatNumber';
import { ActivePoint } from './ActivePoint';
export const legendStyles = (theme) => [
    {
        anchor: 'bottom',
        direction: 'row',
        justify: false,
        translateX: 0,
        translateY: LegendOffset,
        itemsSpacing: 16,
        itemDirection: 'left-to-right',
        itemWidth: 100,
        itemHeight: 20,
        symbolSize: 10,
        symbolShape: 'circle',
        itemTextColor: theme === 'dark' ? DarkTextColor : LightTextColor,
    },
];
export const customizedTheme = (theme) => ({
    axis: {
        ticks: {
            text: {
                fill: theme === 'dark' ? DarkTextColor : LightTextColor,
            },
        },
    },
    crosshair: {
        line: {
            stroke: theme === 'dark' ? DarkDashedGridColor : LightDashedGridColor,
            strokeWidth: 1,
            strokeDasharray: DashedGridSize,
        },
    },
    grid: {
        line: {
            stroke: theme === 'dark' ? DarkDashedGridColor : LightDashedGridColor,
            strokeWidth: 1,
            strokeDasharray: DashedGridSize,
        },
    },
    legends: {
        text: {
            fontSize: LegendFontSize,
        },
    },
});
export const layers = [
    'grid',
    'axes',
    'areas',
    'lines',
    'crosshair',
    'slices',
    'mesh',
    'legends',
    ActivePoint,
];
export const marginStyles = {
    top: 30,
    right: 30,
    bottom: LegendOffset,
    left: 50,
};
export const axisBottomStyles = (adjustX, isMobile, isDesktop) => ({
    tickSize: AxisTickSize,
    tickPadding: AxisTickPadding,
    tickRotation: isMobile ? -90 : isDesktop ? -45 : 0,
    truncateTickAt: 0,
    format: formatDate,
    tickValues: adjustX,
});
export const axisLeftStyles = {
    tickSize: AxisTickSize,
    tickPadding: AxisTickPadding,
    tickRotation: 0,
    truncateTickAt: 0,
    format: formatNumber,
};
export const xScaleStyle = {
    type: 'time',
    format: 'native', // Use 'native' to tell Nivo that you are passing native Date objects
    precision: 'day', // Adjust as needed based on your data's precision
};
export const yScaleStyle = {
    type: 'linear',
    min: 'auto',
    max: 'auto',
    stacked: false,
    reverse: false,
};
